import { render, staticRenderFns } from "./TrPage.vue?vue&type=template&id=f88de58e&scoped=true&"
import script from "./TrPage.vue?vue&type=script&lang=js&"
export * from "./TrPage.vue?vue&type=script&lang=js&"
import style0 from "./TrPage.vue?vue&type=style&index=0&id=f88de58e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88de58e",
  null
  
)

export default component.exports